<div class="scoring-container">
  <header class="header">
    <div class="container-logo">
      <div class="logo">
        <img (click)="goToUrl()" src="./assets/signin/blue_log.png" alt="">
      </div>
    </div>
  </header>
  <div class="resumen">
    <p *ngIf="scoring">{{ getExpression() }}</p>
  </div>
  <div class="scoring">
    <img src="./assets/global-position/summary/scoring/{{ scoring }}.svg"
      alt="No podemos mostrarle en estos momentos su puntuacion, estamos teniendo problemas tecnicos">
    <div class="information">
      <p>
        ¿Te gustaría conocer tu puntuación?
        Con Akana, un servicio seguro y gratuito del Grupo Santander, recibes un informe completo y consejos que te
        ayudarán a mejorar el estado de tu <b>Salud Financiera</b>.
      </p>
      <button (click)="goToUrl()">Quiero probar Akana</button>
    </div>
  </div>
</div>
